import { CircularProgress } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Products = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [pageSize, setPageSize] = useState(10); // Initialize pageSize state
  const [loading, setLoading] = useState();

  const back = () => {
    navigate('/');
  };

  useEffect(() => {
    setLoading(true);
    fetch('https://ibidaz.com/inventory/phpfiles/products.php')
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        setRows(data);
        if (data.length > 0) {
          let cmns = [];
          Object.keys(data[0]).map((ky) => {
            cmns.push({
              field: ky,
              headerName: ky.replace('_', ' '),
              type: 'string',
              width: 150,
            });
          });
          cmns.push({
            field: 'edit',
            headerName: 'Edit',
            sortable: false,
            renderCell: (cellValues) => {
              return (
                <Link
                  className="edit_btn"
                  to={`/product/${cellValues.row.item_id}`}
                  // to={`/product/${cellValues.row.store_sku}`}
                >
                  Edit
                </Link>
              );
            },
          });
          setColumns(cmns);
        }
      })
      .catch((err) => {
        setLoading(false);
        setRows([]);
      });
  }, []);

  return (
    <div className="container">
      <div>
        <button className="logout_btn" onClickCapture={back}>
          Back
        </button>
      </div>
      <br />
      {rows.length > 0 ? (
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)} // Handle page size change
          rowsPerPageOptions={[5, 10, 20, 30, 40, 100]}
          autoHeight
          disableSelectionOnClick
        />
      ) : loading ? (
        <CircularProgress />
      ) : (
        'No products.'
      )}
    </div>
  );
};

export default Products;
